import React, { useEffect } from 'react';
import { Col, FlexboxGrid } from 'rsuite';
import PortalHeader from '../components/layout/PortalHeader';
import UsersLicensesWrapper from '../components/dashboard/UsersLicenses/UsersLicensesWrapper';
import ActionsList from '../components/dashboard/Actions/ActionsList';
import { resetTaxState } from '../store/slices/tax/taxSlice';
import { resetPaymentState } from '../store/slices/payment/paymentSlice';
import { resetLicenseViewState } from '../store/slices/licenseView/licenseViewSlice';
import { resetWorkProgressState } from '../store/slices/auth/authSlice';
import { resetApplyState } from '../store/slices/apply/applySlice';
import { resetUpdateState } from '../store/slices/update/updateSlice';
import { resetRenewState } from '../store/slices/renew/renewSlice';
import {
  getUserLicensesAsync,
  getUsersRenewableLicensesAsync,
} from '../store/slices/userLicenses/userLicensesThunks';
import { useAppDispatch } from 'src/store/store';
import {
  selectRenewableLicenses,
  selectUserLicenses,
} from 'src/store/slices/userLicenses/userLicensesSelectors';
import { useSelector } from 'react-redux';
import { selectConfigExpressRegistrationRenewEnabled } from 'src/store/slices/config/configSelectors';
import { resetRenewableUserLicencesState } from 'src/store/slices/userLicenses/userLicensesSlice';
import { C_DASHBOARD_CONTENT_SECTION_HEIGHT } from 'src/common/consts';

const Dashboard = () => {
  const dispatch = useAppDispatch();
  const renewEnabled = useSelector(selectConfigExpressRegistrationRenewEnabled);

  const {
    data: usersLicenses,
    loading,
    error: errorMessage,
  } = useSelector(selectUserLicenses);

  const renewableLicensesData = useSelector(selectRenewableLicenses);

  useEffect(() => {
    dispatch(resetTaxState());
    dispatch(resetPaymentState());
    dispatch(resetLicenseViewState());
    dispatch(resetApplyState());
    dispatch(resetUpdateState());
    dispatch(resetRenewState());
    dispatch(resetWorkProgressState());
    dispatch(resetRenewableUserLicencesState());
  }, [dispatch]);

  useEffect(() => {
    if (renewEnabled) {
      dispatch(getUsersRenewableLicensesAsync(true));
    }
  }, [renewEnabled]);

  useEffect(() => {
    dispatch(getUserLicensesAsync(true));
  }, []);

  return (
    <FlexboxGrid justify="space-between">
      <FlexboxGrid.Item colspan={24}>
        <PortalHeader />
      </FlexboxGrid.Item>

      <FlexboxGrid.Item
        as="main"
        role="main"
        id="main-content"
        tabIndex={-1}
        className="ph-24 pb-24 mt-20 sm-mt-0 sm-page-padding"
        colspan={24}
        aria-label="Dashboard"
      >
        <FlexboxGrid
          role="grid"
          justify="space-between"
          className="dashboard-columns"
        >
          <FlexboxGrid.Item
            role="row"
            className="ph-24 sm-ph-0 pb-32"
            as={Col}
            colspan={24}
            md={12}
            lg={14}
          >
            <div
              role="cell"
              className="dashboard-panel-cell"
            >
              <ActionsList
                contentSectionHeight={C_DASHBOARD_CONTENT_SECTION_HEIGHT}
                renewableLicensesData={renewableLicensesData}
              />
            </div>
          </FlexboxGrid.Item>

          <FlexboxGrid.Item
            role="row"
            className="ph-24 sm-ph-0 pb-32"
            as={Col}
            colspan={24}
            md={12}
            lg={10}
          >
            <div
              role="cell"
              className="dashboard-panel-cell"
            >
              <UsersLicensesWrapper
                contentSectionHeight={C_DASHBOARD_CONTENT_SECTION_HEIGHT}
                licenses={usersLicenses}
                loading={loading}
                errorMessage={errorMessage}
              />
            </div>
          </FlexboxGrid.Item>
        </FlexboxGrid>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default Dashboard;
